import bankStatementAIService from "../../../services/v2/common/bankStatementAI.service";

export const bankStatementAIApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    run({ commit }, { fileDataId, bankType, embeddedDocIds }) {
      return bankStatementAIService
        .run(fileDataId, bankType, embeddedDocIds)
        .then(
          (resp) => {
            commit("dummyConsole", "BankStatementAIService.run - success");
            return Promise.resolve(resp);
          },
          (error) => {
            commit("dummyConsole", "BankStatementAIService.run - error");
            return Promise.reject(error);
          }
        );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
